import {Tooltip} from 'mui-core';
import PropTypes from 'prop-types';
import {Info} from '@mui/icons-material';
import {Card, Stack, Typography} from '@mui/material';
import {InfoCircle} from 'sharedResources/assets/icons';

const GraphCard = ({
  title,
  children,
  tooltipDesc,
  tooltipTitle,
  paddingX = 3,
  titlePadding = 0,
  borderRadius = '20px',
  variant = 'elevation',
}) => {
  return (
    <Card
      variant={variant}
      sx={{
        pt: '20px',
        pb: '10px',
        px: paddingX,
        height: '320px',
        overflow: 'hidden',
        borderRadius: borderRadius,
        background: 'background.paper',
        width: {xs: 320, sm: 360, md: 320, lg: '33%'},
      }}>
      <Stack gap={2} sx={{width: '100%', height: '100%'}}>
        <Stack
          gap={1}
          direction="row"
          alignItems="center"
          paddingX={titlePadding ? titlePadding : 0}>
          <Typography
            component="h4"
            color="text.primary"
            variant="text-lg-bold">
            {title}
          </Typography>
          {(tooltipTitle || tooltipDesc) && (
            <Tooltip
              tooltipData={
                <Stack gap={2} alignItems="flex-start">
                  {tooltipTitle && (
                    <Stack
                      gap={4}
                      direction="row"
                      alignItems="center"
                      justifyContent="flex-start">
                      <InfoCircle
                        fontSize="50px"
                        color="var(--mui-palette-background-white)"
                        background="var(--mui-palette-primary-main)"
                      />
                      <Typography
                        component="h4"
                        color="text.primary"
                        variant="title-lg-bold">
                        {tooltipTitle}
                      </Typography>
                    </Stack>
                  )}
                  {tooltipDesc && (
                    <Typography
                      color="text.primary"
                      variant="text-md-regular"
                      dangerouslySetInnerHTML={{
                        __html: tooltipDesc,
                      }}
                    />
                  )}
                </Stack>
              }>
              <Info color="primary" fontSize="medium" />
            </Tooltip>
          )}
        </Stack>
        {children}
      </Stack>
    </Card>
  );
};

GraphCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.element,
  tooltipDesc: PropTypes.string,
  tooltipTitle: PropTypes.string,
  borderRadius: PropTypes.string,
  titlePadding: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  paddingX: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default GraphCard;
